"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILWeekdaySelector = void 0;
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var il_button_1 = require("../il-button/il-button");
var il_select_1 = require("../il-select/il-select");
function ILWeekdaySelector(_a) {
    var sx = _a.sx, className = _a.className, enableWeekend = _a.enableWeekend, props = __rest(_a, ["sx", "className", "enableWeekend"]);
    var classes = 'il-weekday-selector ' + className;
    var _b = react_1.default.useState((0, date_fns_1.startOfDay)(props.selectedDate ? new Date(props.selectedDate) : new Date())), selectedDate = _b[0], setSelectedDate = _b[1];
    function onChange(value) {
        var dateValue = new Date(value);
        if (enableWeekend || !(0, date_fns_1.isWeekend)(dateValue)) {
            setSelectedDate(dateValue);
            props.onChange(dateValue);
        }
    }
    function mapWeek(firstDate) {
        return Array.from({ length: 7 }, function (_, i) { return (0, date_fns_1.startOfDay)((0, date_fns_1.addDays)(firstDate, i)); });
    }
    var _c = react_1.default.useState(mapWeek(selectedDate)), mappedDates = _c[0], setMappedDates = _c[1];
    react_1.default.useEffect(function () {
        setSelectedDate((0, date_fns_1.startOfDay)(props.selectedDate ? new Date(props.selectedDate) : new Date()));
    }, [props.selectedDate]);
    react_1.default.useEffect(function () {
        setMappedDates(mapWeek((0, date_fns_1.startOfWeek)(selectedDate)));
    }, [selectedDate]);
    return (react_1.default.createElement(il_select_1.ILSelect, { component: material_1.Box,
        className: classes,
        sx: __assign({ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'stretch', alignContent: 'stretch', width: '100%' }, sx),
        'aria-label': 'weekday select',
        returnValues: mappedDates.map(function (d) { return d.getTime(); }),
        defaultSelections: [selectedDate.getTime()],
        children: mappedDates.map(function (date) {
            return (react_1.default.createElement(il_select_1.RemoveActiveProp, { key: date.getTime() },
                react_1.default.createElement(material_1.Box, { sx: {
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        gap: '0.375rem',
                    } },
                    react_1.default.createElement(material_1.Typography, { variant: enums_1.TypographyVariantEnum.BODY1, sx: {
                            fontSize: '0.75rem',
                            color: 'text.disabled',
                            cursor: 'pointer',
                        } }, (0, date_fns_1.format)(date, 'EEE')),
                    react_1.default.createElement(il_button_1.ILButton, __assign({}, ((0, date_fns_1.isSameDay)(date, selectedDate) && { active: true }), { disabled: !enableWeekend && (0, date_fns_1.isWeekend)(date),
                        sx: {
                            p: '2px 10px',
                            minWidth: 32,
                            maxWidth: 32,
                            fontSize: '1rem',
                            borderRadius: '50%',
                            backgroundColor: 'transparent',
                            boxShadow: 'unset',
                            color: 'text.primary',
                            fontWeight: 'normal',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                                color: 'primary.contrastText',
                            },
                            '&.active, &.Mui-selected': {
                                color: 'primary.contrastText',
                                backgroundColor: 'primary.main',
                                fontWeight: 'bold',
                                borderWidth: '2px',
                                borderColor: 'primary.light',
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                },
                            },
                            '&.Mui-disabled': {
                                backgroundColor: 'transparent',
                            },
                        } }), date.getDate()))));
        }),
        showSelectAll: false,
        variant: enums_1.SelectVariantEnum.SINGLE, onChange: onChange }));
}
exports.ILWeekdaySelector = ILWeekdaySelector;
